import { Head } from "@inertiajs/react";
import { Layout } from "@/components/Layout";
import { CredentialsForm } from "@/components/CredentialsForm";

export default function Login() {
  return (
    <Layout>
      <Head title="Sign in" />
      <div className="mx-auto max-w-sm rounded-xl border border-neutral-200 bg-white p-6 dark:border-neutral-800 dark:bg-neutral-900">
        <h1 className="text-xl font-semibold tracking-tight">Sign in</h1>
        <p className="mt-1 mb-6 text-sm text-neutral-500 dark:text-neutral-400">
          Court Pilot is invite-only. If you have an invite link, open that instead.
        </p>
        <CredentialsForm action="/login" submitLabel="Sign in" />
      </div>
    </Layout>
  );
}
